import { AllotmentService } from './services/allotment.service';
import { ProfileContactFormComponent } from './components/employee/profile-contact-form/profile-contact-form.component';
import { ProfileFormComponent } from './components/employee/profile-form/profile-form.component';
import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';

import { ManagementRoutingModule } from './management-routing.module';
import { ManagementComponent } from './management.component';  
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { TransferRequestListComponent } from './components/transfer-request/transfer-request-list/transfer-request-list.component';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';
import { ServiceBookListComponent } from './components/employee/service-book/service-book-list/service-book-list.component';
import { ServiceBookFormComponent } from './components/employee/service-book/service-book-form/service-book-form.component';
import { PresentPlaceFormComponent } from './components/employee/service-book/present-place-form/present-place-form.component';
import { AllotmentProcessComponent } from './components/allotment/allotment-process/allotment-process.component';
import { AllotmentListComponent } from './components/allotment/allotment-list/allotment-list.component';
import { ExportExcelComponent } from './components/allotment/export-excel/export-excel.component';
import { AllotmentFormComponent } from './components/allotment/allotment-form/allotment-form.component';
import { TransferOrderListComponent } from './components/transfer-order/transfer-order-list/transfer-order-list.component';
import { TransferOrderFormComponent } from './components/transfer-order/transfer-order-form/transfer-order-form.component';
import { TransferOrderExportComponent } from './components/transfer-order/transfer-order-export/transfer-order-export.component';
import { ViewEmployeeProfileComponent } from './components/employee/view-employee-profile/view-employee-profile.component';

@NgModule({  
  declarations: [
    ManagementComponent,                                     
    HomeComponent,
    HeaderComponent,
    BreadcrumbComponent,
    SidebarComponent,
    EmployeeListComponent,
    TransferRequestListComponent,
    TransferRequestViewComponent,
    ProfileFormComponent,
    ProfileContactFormComponent,
    ServiceBookFormComponent,
    ServiceBookListComponent,
    PresentPlaceFormComponent,
    AllotmentProcessComponent,
    AllotmentListComponent,
    ExportExcelComponent,
    AllotmentFormComponent,
    TransferOrderListComponent,
    TransferOrderFormComponent,
    TransferOrderExportComponent,
    ViewEmployeeProfileComponent,
  ],
  imports: [
    SharedModule,
    ManagementRoutingModule
  ],
  providers: []
})
export class ManagementModule { }
